import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import buildSubjectPath from '@UI/Pages/Beneficiaries/Shared/Helpers/buildSubjectPath';
import { useSearchParams } from 'react-router-dom';

export type DocumentListReturn = {
	readonly listPath: string;
};

/**
 * The way back to the documents list, read from `?from=list`: `null` when the screen was not opened
 * from that list. A review stage (`useReviewStage`) takes precedence over it where both are present.
 */
const useDocumentListReturn = (subject: SubjectAddress): DocumentListReturn | null => {
	const [searchParams] = useSearchParams();

	if (searchParams.get('from') !== 'list') {
		return null;
	}

	return { listPath: `${buildSubjectPath(subject)}/documents` };
};

export default useDocumentListReturn;
